import 'slick-carousel';

/**
 * Initialize announcement slider
 * @param  {String} slider - Main announcement slider selector
 * @return {Void}
 */

export const initAnnouncements = (slider = '.js-slider-announcements') => {
  const config = {
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    arrows: false,
    infinite: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  $(slider).not('.slick-initialized').slick(config);
};

initAnnouncements();

$(window).on('shopify:section:load', function(event) {
	initAnnouncements();
});
